import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=3662a9f5&scoped=true&"
import script from "./Tasks.vue?vue&type=script&lang=ts&"
export * from "./Tasks.vue?vue&type=script&lang=ts&"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=3662a9f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3662a9f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3662a9f5')) {
      api.createRecord('3662a9f5', component.options)
    } else {
      api.reload('3662a9f5', component.options)
    }
    module.hot.accept("./Tasks.vue?vue&type=template&id=3662a9f5&scoped=true&", function () {
      api.rerender('3662a9f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Tasks.vue"
export default component.exports